module.exports = __webpack_public_path__ + "img/pageIndex_bg.daddb835.png";